<script setup lang="ts"></script>

<template>
  <div class="switcher-wrapper flex-center">
    <router-link
      to="/"
      class="switcher-tab"
    >
      {{ $t('routeTabs.messages') }}
    </router-link>
    <router-link
      to="/templates"
      class="switcher-tab"
    >
      {{ $t('routeTabs.templates') }}
    </router-link>
  </div>
</template>

<style lang="scss">
.tab-btn, .switcher-tab {
  &.disabled {
    cursor: not-allowed;
  }
}
</style>

<style scoped lang="scss">
.switcher-wrapper {
  background-color: var(--white);
  padding: 0 30px;
  border-bottom: 1px solid var(--border-default);
}

.switcher-tab {
  padding: 20px;
  cursor: pointer;
  color: var(--text-color-gray);

  &.router-link-active {
    border-bottom: 2px solid var(--primary);
    color: var(--primary);
  }
}
</style>
